import { CAMPAIGNS } from 'constants/Entities';

import { canAccessMarketingCampaigns } from '../marketing/utils/marketingCampaignPermissions';

export function canAccessSalesCampaigns(state) {
    return Boolean(state?.config?.permission?.verCampaignsAdmin);
}

export function canAccessEmailCampaigns(state) {
    return Boolean(
        state?.config?.userData?.marketingCampaigns && canAccessMarketingCampaigns(state),
    );
}

export function canAccessCampaignsSection(state) {
    return canAccessSalesCampaigns(state) || canAccessEmailCampaigns(state);
}

export function shouldShowCampaignsTabs(state) {
    return canAccessSalesCampaigns(state) && canAccessEmailCampaigns(state);
}

export function getCampaignsDefaultRoute(state) {
    return canAccessSalesCampaigns(state) ? CAMPAIGNS.route : '/campaigns/marketing';
}
